import { Context } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function subscribeDelete({ client, config }: Context): Promise<ApiResult> {
  const param = {};
  const url = new URL('/mall/subscribes/delete', config.api.url);
  const { data: res } = await client.post(url.href, param);
  return res;
}
